<template>
<v-row>
    <v-dialog v-model="isVisible" absolute max-width="1000" scrollable>
        <v-card>
            <v-form ref="form">
                <v-card-title class="primary-header pa-3">
                    백테스트 설정 불러오기
                </v-card-title>

                <v-card-text class="px-3">
                    <div class="pa-3 text-center" v-if="isLoading">
                        <v-progress-circular indeterminate color="primary" />
                    </div>

                    <v-radio-group v-model="selected" hide-details @change="onSelectedChange">
                        <v-row class="mx-1 my-2" v-for="(item, i) in savedUrls" :key="i" align="center">
                            <v-col class="pa-0 ma-0" cols="2">
                                <v-radio :value="i" :label="item.name" />
                            </v-col>
                            <v-col cols="8" class="pa-0" style="font-size: 12px">{{ item.url }}</v-col>
                            <v-col class="pa-0 text-center">
                                <v-btn icon v-clipboard:copy="copyItem(item.url)" v-clipboard:success="onCopySuccess">
                                    <v-icon color="primary">content_copy</v-icon>
                                </v-btn>
                                <v-btn icon @click="deleteItem(i)">
                                    <v-icon color="primary">delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-radio-group>
                    <v-row class="ma-0 pa-0">
                        <v-checkbox v-model="isCustom" readonly />
                        <v-text-field v-model="customUrl" label="직접 입력" @click="onFieldClicked" hide-details />
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text" color="primary" @click="load">불러오기</v-btn>
                    <v-btn class="white--text" color="red" @click="close">닫 기</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</v-row>
</template>

<script>
import firebase from 'firebase/app'
import {
    db,
    auth
} from '@/firebase'

export default {
    name: 'load-dialog',
    data() {
        return {
            isVisible: false,
            sort: '',
            selected: 0,
            savedUrls: [],
            customUrl: '',
            isCustom: false,
            isLoading: false
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
    },
    methods: {
        async show(sort) {
            this.savedUrls = []
            this.isVisible = true
            this.sort = sort

            this.isLoading = true
            if (this.user.backTest) {
                const batch = db.batch()
                for (const data of this.user.backTest) {
                    batch.set(db.collection('users').doc(this.user.id).collection('quant').doc(), data)
                }

                batch.update(db.collection('users').doc(this.user.id), {
                    backTest: firebase.firestore.FieldValue.delete()
                })
                await batch.commit()
            }

            this.savedUrls = await db.collection('users').doc(this.user.id).collection(this.sort).parseCollection()
            this.isLoading = false
        },
        load() {
            let loadData = ''
            if (this.selected != null) {
                loadData = this.savedUrls[this.selected].url
            } else {
                loadData = this.customUrl
            }

            this.$emit('load', loadData)
            this.close()
        },
        close() {
            this.isVisible = false
        },
        deleteItem(i) {
            if (!confirm('정말 삭제하시겠습니까?')) return

            const item = this.savedUrls[i]
            db.collection('users').doc(this.user.id).collection(this.sort).doc(item.id).delete()
            this.savedUrls.splice(i, 1)
        },
        onFieldClicked() {
            this.selected = null
            this.isCustom = true
        },
        onSelectedChange() {
            this.isCustom = false
        },
        onCopySuccess() {
            this.$toasted.success('클립보드에 복사됐습니다')
        },
        copyItem(item) {
            return JSON.stringify(item)
        }
    }
}
</script>
